import { useI18n } 						from '../../../../shared/i18n/useI18n.js';
import { useProductStrings } 	from '../../../../shared/i18n/useProductStrings.js';

import { Button }       from '../../../../shared/ui/Button/Button.jsx';
import { Inquiry } 			from '../../../../shared/ui/icons/Inquiry.jsx';
import { Logger } 			from '../../../../shared/utils/logger.js';
import { Tooltip }      from '../../../../shared/ui/Tooltip/Tooltip.jsx';

import styles from './ProductList.module.scss';

export function ProductInquiryCell({ product }) {
	const { t } = useI18n();
  const getProductsCategoryString = useProductStrings()

  const idOriginal = product?.id_original ?? product.cms_product_name ?? product?.id_cad ?? null

  const eventDetail = {
    units: [{
      investmentId: product?.crm_id_investment ?? null,
      stageId: product?.crm_id_stage ?? null,
      buildingId: product?.crm_id_building ?? null,
      unitId: product?.crm_id_unit ?? product?.number ?? product?.id_cad ?? null,
      unitName: idOriginal,
      userAddedItems: []
    }]
  };

	const handleClick = () => {
    Logger.info({
      message: 'Catalog ProductList cadaplusProductQueryClick event dispatched',
      content: `${JSON.stringify(eventDetail)}`
    })
    const event = new CustomEvent('cadaplusProductQueryClick', {
      detail: {
        ...eventDetail
      },
      bubbles:  true,
      composed: true,
    })
    document.dispatchEvent(event)
  }

	return (
		<div>
			<Tooltip
				title={
					`${
						t('common.send_inquiry')
					} ${
						getProductsCategoryString('about', product.product_category, { id: idOriginal })
					}`
				}
				placement="top"
				disableOnMobile
			>
				<Button
					type="button"
					size="small"
					variant="ghost"
					// className={styles.actionBtn}
					onClick={(e) => {
						e.stopPropagation();
						handleClick();
					}}
					onTouchEnd={(e) => e.stopPropagation()}
					aria-label={t('common.send_inquiry')}
				>
					<Inquiry />
				</Button>
			</Tooltip>
		</div>
	);
}